module.exports = __webpack_public_path__ + "img/caas4m.322fb43e.jpg";